import { render, staticRenderFns } from "./AppPaySucceed.vue?vue&type=template&id=2efcd078&scoped=true&"
import script from "./AppPaySucceed.vue?vue&type=script&lang=js&"
export * from "./AppPaySucceed.vue?vue&type=script&lang=js&"
import style0 from "./AppPaySucceed.vue?vue&type=style&index=0&id=2efcd078&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efcd078",
  null
  
)

export default component.exports